$(document).ready(function() {



  // Above the fold section

  $('.above-the-fold').each(function(){

    var header_height = $('#body-header').height();

    if(header_height == null){

      header_height = 0;

    }

    header_height += 'px';



    $(this).css({"height" : "calc( 100vh - " + header_height + " )" });

  });

});